import React from "react";
import arrowRightTop from "./common-icons/right-arrow.svg";
import styles from "./InfoBoxRedirectButton.module.css";

/**
 * "View all" link-style button for info box headers.
 *
 * @param {Function} onClick - click handler
 * @param {string} label - accessible name / tooltip, e.g. "View all failed patch installs".
 *                         Should start with the visible text so screen-reader
 *                         and voice-control users get a matching name.
 * @param {string} text - visible text (defaults to "View all")
 */
const InfoBoxRedirectButton = ({ onClick, label, text = "View all" }) => (
  <button
    type="button"
    className={styles.button}
    onClick={onClick}
    aria-label={label || text}
    title={label || text}
  >
    <span className={styles.text}>{text}</span>
    <img
      className={styles.icon}
      src={arrowRightTop}
      alt=""
      aria-hidden="true"
    />
  </button>
);

export default InfoBoxRedirectButton;
